import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../servicestypes/webdevelopment/webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import cloudimage from '../../../assests/cloud integration.jpeg';

const Cloudintegration = () => {
  return (
    <Card className="webdevelopment-card">
      
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="Cloud Integration & DevOps"
          src={cloudimage}
        />
        
     
        <div className="contact-info">
          <Typography variant="h6" component="div" gutterBottom className="contact-title">
            Contact Information
          </Typography>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">+919060237575</Typography>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
          </div>
          <div className="contact-item">
            <LocationOnIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Samastipur, Bihar (848101)</Typography>
          </div>
        </div>
        
     
        <Link to="/Services">
          <button className="comic-button">Back</button>
        </Link>
      </Grid>
      
     
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            Cloud Integration & DevOps
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Cloud Infrastructure Setup:</strong> Setting up cloud environments on AWS, Azure, or Google Cloud.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Continuous Integration/Continuous Deployment (CI/CD):</strong> Automating code deployment and testing pipelines.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Infrastructure as Code (IaC):</strong> Managing cloud infrastructure with tools like Terraform and AWS CloudFormation.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Containerization with Docker:</strong> Packaging applications in containers for consistency across environments.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Serverless Architecture:</strong> Building and deploying serverless applications with AWS Lambda or Azure Functions.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Monitoring and Logging:</strong> Implementing tools like Prometheus, Grafana, or ELK Stack for real-time monitoring.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Cloud Security:</strong> Ensuring data security and compliance with cloud-based services.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Backup and Disaster Recovery:</strong> Setting up automated backups and recovery processes.
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Cloudintegration;
